// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatarCircle_avatar__HD1wh"};